import React from 'react';
import { ViewabilityElement } from 'mm-ui-components';
import { sendPageView } from 'mm-client-core';
import { useSelector } from 'react-redux';
import { ArticlePageViewParameters, ConfigPageViewParameters } from '../../templates/utils/articleComponent.utils';
import {
  getAdSlots,
  getDfpProperty,
  getEdition,
  getHeaderBidderPublisherID,
  getLanguage,
  getPageType,
  getSiteName,
} from '../../store/config/config.selectors';
import { getCountryCode } from '../../templates/templates.utils';

interface ArticleUrlProp {
  articleURL: string;
}

type ArticlePageViewEventProps = ArticlePageViewParameters & ArticleUrlProp
export const ArticlePageViewEvent: React.FunctionComponent<ArticlePageViewEventProps> = props => {
  const {
    children,
    ownerUsername,
    articleTitle,
    articleAuthor,
    articleContentCount,
    articleId,
    articlePublicationTime,
    articleTemplate,
    articleWordCount,
    channels,
    commercialTags,
    contentTags,
    dfpCategory,
    mainMedia,
    articleURL,
    createdAt,
    isSlideshow,
  } = props;
  const siteName = useSelector(getSiteName);
  const language = useSelector(getLanguage);
  const pageType = useSelector(getPageType);
  const property = useSelector(getEdition);
  const adSlots = useSelector(getAdSlots);
  const headerBidderPublisherID = useSelector(getHeaderBidderPublisherID);
  const dfpProperty = useSelector(getDfpProperty);

  const sendPageViewForArticle = React.useCallback(() => {
    const pageParameters: ArticlePageViewParameters & ArticleUrlProp & ConfigPageViewParameters = {
      ownerUsername,
      articleTitle,
      articleAuthor,
      articleContentCount,
      articleId,
      articlePublicationTime,
      articleTemplate,
      articleWordCount,
      channels,
      commercialTags,
      contentTags,
      dfpCategory,
      mainMedia,
      siteName,
      language,
      pageType,
      property,
      adSlots,
      headerBidderPublisherID,
      countryCode: getCountryCode(),
      dfpProperty,
      category: null,
      articleURL,
      createdAt,
      isSlideshow,
    };
    sendPageView(pageParameters);
  }, [adSlots, articleAuthor, articleContentCount, articleId, articlePublicationTime, articleTemplate, articleTitle, articleURL, articleWordCount, channels, commercialTags, contentTags, createdAt, dfpCategory, dfpProperty, headerBidderPublisherID, isSlideshow, language, mainMedia, ownerUsername, pageType, property, siteName]);

  return (
    <ViewabilityElement viewabilityCallback={sendPageViewForArticle}>
      {children}
    </ViewabilityElement>
  );
};
